import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { HEADINGS } from "@/utils/constants/appConstants/commonConstants";
import AddUserTable from "@/components/tables/AddUserTable";
import { BUTTONS } from "@/utils/constants/appConstants/commonConstants";
import AppButton from "@/components/buttons/AppButton";

export interface AddADModalProps {
    show?: boolean;
    onHide?: () => void;
    onUsersSelected: (users: string[]) => void;
    tab: string;
}

export const AddADUserModal = (props: AddADModalProps) => {
    const [selectedUsers, setSelectedUsers] = React.useState<any>([]);
    const [isSelectAll, setIsSelectAll] = React.useState<boolean>(false);

    const handleUserSelect = (user: any) => {
        if (props.tab === "single") {
            setSelectedUsers([user]);
        } else {
            setSelectedUsers((prevSelectedUsers: any) =>
                prevSelectedUsers.includes(user)
                    ? prevSelectedUsers.filter((u: any) => u !== user)
                    : [...prevSelectedUsers, user]
            );
        }
    };

    const handleSelectAll = (users: any[]) => {
        if (isSelectAll) setSelectedUsers([]);
        else setSelectedUsers(users);
        setIsSelectAll(!isSelectAll);
    };

    const handleApply = () => {
        props.onUsersSelected(selectedUsers);
        setSelectedUsers([]); setIsSelectAll(false);
        props.onHide?.();
    };

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent className="sm:max-w-2xl">
                <DialogHeader>
                    <DialogTitle id="add-group-title">{HEADINGS.ADD_USERS}</DialogTitle>
                </DialogHeader>
                <div className="max-h-[70vh] overflow-auto pt-0 px-6">
                    <AddUserTable tab={props.tab} handleUserSelect={handleUserSelect} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} />
                </div>
                <DialogFooter>
                    <AppButton id="add-user-from-ad-done-btn" btnText={BUTTONS.ADD} className={"btn-primary"} onClick={handleApply} />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
